import { createTheme } from '@mui/material';
// import './types';

const commonFocusStyle = {
  '&.Mui-focusVisible': {
    outline: '2px solid #2057A6',
    outlineOffset: '2px',
    disableRipple: true,
    disableTouchRipple: true,
  },
};

const theme = createTheme({
  typography: {
    fontFamily: 'Work Sans, sans-serif',
  },
  palette: {
    primary: {
      main: '#2057A6',
    },
    secondary: {
      main: '#131836',
    },
    text: {
      primary: '#293139',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: {
          color: '#fff',
          borderRadius: '5px',
          textTransform: 'none',
          fontWeight: 'bold',
          fontSize: '18px',
          padding: '10px',
          ...commonFocusStyle,
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: {
          ...commonFocusStyle,
        },
      },
    },
    MuiMenuItem: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: { ...commonFocusStyle },
      },
    },
    MuiListItemButton: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: {
          color: '#2A7F83',
          ...commonFocusStyle,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '.warning-note': {
          transition: 'color 0.2s ease',
          '&:focus-visible': {
            color: '#BD1A1A',
            outline: '2px solid #2057A6',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.warning-note': {
            '&:focus-visible': {
              color: '#BD1A1A',
              outline: '2px solid #2057A6',
              outlineOffset: '2px',
            },
          },
        },
      },
    },
  },
});

export default theme;
